import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import {
  CreateUpdateMediationDocumentDto,
  CreateUpdateMediationDto,
  CreateUpdateMediationPartyDto,
  MediationDisputeDocumentDto,
  MediationDisputePartyDto,
  MediationDto,
} from "../../models/dispute-resolution/mediation-models";

@Injectable({
  providedIn: "root",
})
export class MediationService {
  private readonly baseUrl = "/api/dispute-resolution/mediation";
  private readonly partyBaseUrl = `${this.baseUrl}/parties`;
  private readonly documentBaseUrl = `${this.baseUrl}/documents`;

  constructor(private http: HttpClient) { }

  create(request: CreateUpdateMediationDto): Observable<MediationDto> {
    return this.http.post<MediationDto>(`${this.baseUrl}`, request);
  }

  getById(id: string): Observable<MediationDto> {
    return this.http.get<MediationDto>(`${this.baseUrl}/${id}`);
  }

  update(id: string, request: CreateUpdateMediationDto): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/${id}`, request);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  getAll(): Observable<MediationDto[]> {
    return this.http.get<MediationDto[]>(`${this.baseUrl}`);
  }

  generateCaseNumber(): Observable<string> {
    return this.http.get(`${this.baseUrl}/generate-case-number`, {
      responseType: "text",
    });
  }

  updateCaseStatus(
    disputeCaseId: string,
    workflowStatusChangesId: string
  ): Observable<void> {
    return this.http.put<void>(
      `${this.baseUrl}/update-case-status/${disputeCaseId}/${workflowStatusChangesId}`,
      null
    );
  }

  createParty(
    request: CreateUpdateMediationPartyDto
  ): Observable<MediationDisputePartyDto> {
    return this.http.post<MediationDisputePartyDto>(
      `${this.partyBaseUrl}`,
      request
    );
  }

  updateParty(
    id: string,
    request: CreateUpdateMediationPartyDto
  ): Observable<void> {
    return this.http.put<void>(`${this.partyBaseUrl}/${id}`, request);
  }

  createDocument(
    request: CreateUpdateMediationDocumentDto
  ): Observable<MediationDisputeDocumentDto> {
    return this.http.post<MediationDisputeDocumentDto>(
      `${this.documentBaseUrl}`,
      request
    );
  }

  getDocumentsByDisputeCase(
    disputeCaseId: string
  ): Observable<MediationDisputeDocumentDto[]> {
    return this.http.get<MediationDisputeDocumentDto[]>(
      `${this.documentBaseUrl}/case/${disputeCaseId}`
    );
  }

  deleteDocument(id: string): Observable<void> {
    return this.http.delete<void>(`${this.documentBaseUrl}/${id}`);
  }
}
